export default __webpack_public_path__ + "static/media/email-img.e43b1126.png";